/**
 * Labstep
 */

import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';

export interface EntityStateWorkflowStatusIndicatorProps {
  experimentWorkflow: ExperimentWorkflow;
}

export enum EntityStateWorkflowStatusIndicatorSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
